(ns web3.screens.home
  (:require [web3.routing.core :as routing]
            [web3.components.card :as card]
            [web3.view :as v]
            [web3.components.icons :as icons]
            [web3.components.badge :as badge]
            [web3.i18n :as i]
            [reagent.core :as r]
            [web3.components.widgets :as widgets]
            [web3.persistence.deletions :as deletions]
            [web3.queries.asset :as q-asset]
            [web3.components.parent :as parent]
            [web3.screens.content :as content]
            [web3.backend-stubs :as backend-stubs]
            [web3.screens.pro.utils :as pro-utils]
            [re-frame-simple.db :as db]
            [web3.ui-state :as ui-state]
            [web3.persistence.current-property :as current-property]
            [web3.components.top-nav :as top-nav]
            [web3.persistence.schema :as schema]
            [web3.view.hiccup :as hiccup]
            [web3.log :as log]))

(defn delete-group [group]
  (deletions/delete-with-confirm
    (merge group
           {:text-primary
            (i/get :group/delete.primary group)
            :text-secondary
            (i/get :group/delete.secondary)

            :confirm
            {:text-primary
             (i/get :group/delete.confirm-contents.primary group)

             :text-secondary
             #(some->> (let [group (:entity (q-asset/asset-group {:id (:id group)}))]
                         (concat (:assets group)
                                 (:content group)))
                       (seq)
                       (map schema/entity-display-name)
                       (i/parse-collection)
                       (i/get :group/delete.confirm-contents.secondary))}

            :mutate!
            (partial q-asset/asset-group-delete! {:id (:id group)})

            :snack
            (i/get :group/delete-complete)})))

(defn does-not-belong-to-any-asset-group [content]
  (nil? (:name (:parent content)   )  )
  )
(defn assets-belong-to-no-asset-groups [contents]
  (filter does-not-belong-to-any-asset-group  contents)
  )
(defn add-first-vec
  [target addition]
  (apply conj (if (vector? addition) addition [addition]) target))
(v/defview screen
           {:nav-view top-nav/welcome
            :component-will-mount
                      #(when (db/get :setup/first-mount)
                         (db/assoc! :setup/first-mount false)
                         (when (and (pro-utils/pro?) (not (ui-state/mobile?)))
                           (routing/nav! (routing/path-for [:pro/dashboard]))))}
           ;;TODO Hack, should impl this in auth-flow but queries aren't ready yet

           [{:keys [property-id]}]
           (when-let [{:as property
                       property-id :id} (current-property/get-property property-id)]
             ;(log/println "icons-" (icons/get :group/not-found))
             (let [{:keys [state]} (r/current-component)
                   edit-korks [:edit :home]
                   edit? (routing/get-query edit-korks)
                   {:keys [assetGroups]
                    :as current-property} property
                   {{:keys [contents]} :entity
                    content-loading? :graphql/loading?} (q-asset/entity-content-simple
                                                          {:id property-id
                                                           :typeName "Property"})]
               ;(log/info "sponsors-"    )
               [:div.pad-h-3
                [card/card-grid

                 {:add-card-props
                  {:id "button-add-group"
                   :href (routing/path-for [:add/group])
                   :label (i/get :i/add-group)}
                  :before
                  [:div.flex-none.width-100p.flex.flex-column.items-stretch.pad-h-1
                   (when current-property
                     [card/group
                      [:span.text-category
                       (i/get :i/my-groups)]
                      (widgets/edit-pencil
                        {:on-click #(routing/set-query! edit-korks (not edit?))
                         :class (str "margin-left-2 " (when edit? "icon--active"))})])]}


                 (when current-property
                   (def tmp-asset assetGroups)
                   (def homeserve-plans-ico {:id         "my-account-grp",
                                             :__typename "link",
                                             :name       (i/get :i/my-account) ,
                                             :sample     false,
                                             :assets [],
                                             :link-img (str "/images/homeserve-logo.svg")}  )
                   (def asset-groups-alt (add-first-vec assetGroups homeserve-plans-ico) )
                   (log/println edit?)
                   (doall
                     (for [{:keys [name createdAt assets __typename link-img]
                            group-id :id
                            :as group} asset-groups-alt]
                       (merge (if edit?
                                {:on-delete (partial delete-group group)}
                                {:href (routing/path-for [:group
                                                          :property-id property-id
                                                          :group-id group-id])})
                              (when-not (zero? (count assets))
                                {:badge (cond (some #(-> % :recalls) assets) [badge/recalled-badge]
                                              (some #(-> % :alertStatus (= "errored")) assets) [badge/error-badge]
                                              :else [badge/badge {:key group-id} (count assets)])})
                              (if (= __typename "link")
                                {:on-click #(re-frame.core/dispatch [:do/redirect.policy])
                                 } )
                              {:key group-id
                               :id group-id
                               :label name
                               :__typename __typename
                               :createdAt createdAt
                               :icon (if (= __typename "link")
                                       [:img {:alt (str name)
                                              :src (str link-img)
                                              :height "70%"
                                              :width "70%"}]
                                       (-> (or (icons/get (backend-stubs/name->group name))
                                               (icons/get :group/not-found))
                                           (hiccup/size 64)
                                           (hiccup/class "margin-top-3")) )
                               }
                              ))))]
                [:div.margin-top-6.margin-left-n3.margin-right-n3.margin-bottom-6
                 (when-not content-loading?
                   [content/user-contents-by-category
                    {:contents (assets-belong-to-no-asset-groups contents)
                     ; {:contents        contents
                     :edit?           edit?
                     :editable?       true
                     :collapse-empty? true
                     :label-prefix    (i/get :i/property)
                     :add-query       (parent/modal-query-data {:root      property-id
                                                                :root-type "Property"})}])]])))
(comment
  (def content-with-no-asset-group [ {:description nil, :category (symbol "image")  , :__typename (symbol "Content" ),
  , :parent {:id "61934847-b75f-4814-886e-f52307715554", :__typename (symbol "Property" )}, :createdAt "2021-11-16T06:20:46.733Z" ,
                                      :curated false,  :mediaType "image/jpeg" , :title "fridge.jpg" , :link "https://homeserve-web-local.s3.amazonaws.com/6e5353e9-85a0-4d89-b550-9ad273a0b938.jpg2ae61b308"}
                                    ]
    )
  (def content-with-asset-group  [ {:description nil, :category (symbol "image")  , :__typename (symbol "Content" ),
                                    :parent {:id "6193484d-7aac-4c04-9760-c25512279513" , :__typename (symbol "AssetGroup"), :name "Pool" , :createdAt "2021-11-16T05:57:33.478Z" , :sample false},
                                    :createdAt "2021-11-16T06:20:46.733Z" , :curated false,
                                    :mediaType "image/jpeg" , :title "fridge.jpg" , :link "https://homeserve-web-local.s3.amazonaws.com/6e5353e9-85a0-4d89-b550-9ad273a0b938.jpg2ae61b308"
                                    }] )


  (filter does-not-belong-to-any-asset-group  content-with-asset-group)
  )
